import { initMicrofrontend } from '../initMicrofrontend';
import { createApplicationContext } from '../createApplicationContext';
import { createApplicationState } from '../createApplicationState';

export const runApp = () => {
  const context = createApplicationContext();

  const store = createApplicationState(context);

  initMicrofrontend(context, store);
};
